import { lazy, Suspense } from 'react'
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { PortalLoginPage } from '@portals/shared/components/PortalLoginPage'
import { ForgotPasswordPage } from '@portals/shared/components/ForgotPasswordPage'
import { ResetPasswordPage } from '@portals/shared/components/ResetPasswordPage'
import { VerifyEmailPage } from '@portals/shared/components/VerifyEmailPage'
import '@/App.css'
import { ToastProvider } from '@/components/feedback/ToastProvider'
import { DialogProvider, LoadingState } from '@/components/ui'

// KAN-1181: the landing page and the whole retail storefront tree are separate chunks so
// the initial load of "/" doesn't also pull the storefront (which itself lazy-loads its pages).
const HomePage = lazy(() => import('@pages/HomePage'))
const RetailWebsite = lazy(() => import('@pages/RetailWebsite'))

export function CustomerPortal() {
  return (
    <Router>
      <ToastProvider>
        <DialogProvider>
        <Suspense fallback={<LoadingState label="Loading…" />}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route
            path="/login"
            element={
              <PortalLoginPage
                portal="customer"
                title="Customer Sign In"
                description={[
                  'Log in to track your orders, manage saved addresses, and access your cart across devices.'
                ]}
                scope="retail"
                redirectPath="/retail"
                allowedRoles={['CUSTOMER', 'SELLER', 'DELIVERY_AGENT', 'RETAIL_MANAGER', 'CUSTOMER_CARE', 'SUPER_ADMIN', 'AUDITOR']}
              />
            }
          />
          {/* Account recovery (KAN-782) */}
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/verify-email" element={<VerifyEmailPage />} />
          <Route path="/retail/*" element={<RetailWebsite />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        </Suspense>
        </DialogProvider>
      </ToastProvider>
    </Router>
  )
}
